import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import classnames from "classnames";
import { getSlugForSolution } from "../../utils/solutionSlug";
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";
import styles from "./faq-related-solutions.module.scss";

function FAQRelatedSolutions({ solutions, className, inContactUs, setSolutionId, scrollToResult, setQuery }) {
  const handleClick = id => {
    dispatchNewEvent("dataStateChange", {
      action: "faq.Event",
      type: "relatedViewed",
    });
    if (inContactUs) {
      scrollToResult();
      setSolutionId(id);
      setQuery("");
    }
  };

  return (
    <div className={classnames(styles.faqRelatedSolutions, className)}>
      <h3 className={styles.faqRelatedSolutions__title}>Related questions</h3>
      <ol className={styles.faqRelatedSolutions__list}>
        {solutions.map(solution => (
          <li key={solution.id} className={styles.faqRelatedSolutions__listItem}>
            {!inContactUs ? (
              <Link href={`/faq/${getSlugForSolution(solution)}`}>
                <div
                  className={styles.faqRelatedSolutions__link}
                  onClick={handleClick}
                  data-test="faq-related-solution-link"
                >
                  {solution.title}
                </div>
              </Link>
            ) : (
              <a
                className={styles.contactUsRelatedSolutions__link}
                onClick={() => handleClick(solution.id)}
                data-test="faq-related-solution-link"
              >
                {solution.title}
              </a>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}

FAQRelatedSolutions.propTypes = {
  solutions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
  inContactUs: PropTypes.bool,
  setSolutionId: PropTypes.func,
  scrollToResult: PropTypes.func,
  setQuery: PropTypes.func,
};

FAQRelatedSolutions.defaultProps = {
  solutions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  className: undefined,
  inContactUs: false,
  setSolutionId: undefined,
  scrollToResult: undefined,
  setQuery: PropTypes.func,
};

export default FAQRelatedSolutions;
